module.exports = __webpack_public_path__ + "static/img/1.c0de81c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR410A/1.jpg
// module id = JPhQ
// module chunks = 1